import { CustomAxios } from '../../redux/axios';
import axios from 'axios';

export interface BulkOperationResult {
  locationId: string;
  success: boolean;
  error?: string;
}

export interface BulkOperationSummary {
  total: number;
  succeeded: number;
  failed: number;
  results: BulkOperationResult[];
}

export const bulkUserAccessApi = {
  addRoleBulk: async (
    userId: string,
    locationIds: string[],
    roles: number[]
  ): Promise<BulkOperationSummary> => {
    const promises = locationIds.map(async (locationId) => {
      try {
        await CustomAxios.post('/auth-api/v3/addorreplaceuseraccess', {
          user_id: userId,
          user_access: {
            location_id: locationId,
            roles: roles,
            accepted: false,
          },
          add_access: true,
        });
        return { locationId, success: true } as BulkOperationResult;
      } catch (error) {
        const errorMessage = axios.isAxiosError(error)
          ? error.response?.data?.message || error.message
          : error instanceof Error
          ? error.message
          : 'Unknown error';
        return {
          locationId,
          success: false,
          error: errorMessage,
        } as BulkOperationResult;
      }
    });

    const results = await Promise.all(promises);
    const succeeded = results.filter((r) => r.success).length;

    return {
      total: locationIds.length,
      succeeded,
      failed: locationIds.length - succeeded,
      results,
    };
  },

  deleteAccessBulk: async (
    userId: string,
    locationIds: string[]
  ): Promise<BulkOperationSummary> => {
    const headerLocation =
      CustomAxios.getBaseUrl() === 'https://api.weaveconnect.com'
        ? 'dfbbf8cd-ac87-42be-87fc-2c243272f122'
        : '897b5b00-57cf-423e-b13e-646ab73880fb';

    const promises = locationIds.map(async (locationId) => {
      try {
        await CustomAxios.delete(`/portal/v1/users/${userId}/access/${locationId}`, {
          headers: {
            'location-id': headerLocation,
          },
        });
        return { locationId, success: true } as BulkOperationResult;
      } catch (error) {
        const errorMessage = axios.isAxiosError(error)
          ? error.response?.data?.message || error.message
          : error instanceof Error
          ? error.message
          : 'Unknown error';
        return {
          locationId,
          success: false,
          error: errorMessage,
        } as BulkOperationResult;
      }
    });

    const results = await Promise.all(promises);
    const succeeded = results.filter((r) => r.success).length;

    return {
      total: locationIds.length,
      succeeded,
      failed: locationIds.length - succeeded,
      results,
    };
  },
};
